<template>
  <div>
    <div class="sms-node">
      <div class="mb-6">
        <gd-tabs
          :tabs="smsTabs"
          :currentTab="currentSmsTab"
          :wrapper-class="'gs-default-tabs'"
          :tab-class="mainTabClass"
          :tab-active-class="'p-2 border-primary border-b-2 text-primary gs-default-tabs-item-active'"
          :line-class="'gs-default-tabs-active-line'"
          @onClick="handleSmsTabChange"
        />
      </div>
      <div class="step3 mb-6" v-if="currentSmsTab === 'settings'">
        <div class="flex flex-no-wrap flex-col">
          <div class="flex flex-col w-full">
            <label class="font-semibold text-base text-dark mb-2">
              {{ $t('frontend_groovemail_adminsetting_name') }}
            </label>
            <text-input
              class="broadCast-name"
              variant="base"
              v-model="localModel.broadcast"
              :placeholder="$t('frontend_groovemail_adminsetting_name')"
              :validator="$v.localModel.broadcast"
            />
          </div>
        </div>
      </div>

      <!-- start step 4 -->
      <div class="step4 mb-6" v-if="currentSmsTab === 'settings'">
        <div class="flex flex-no-wrap flex-col">
          <label class="font-semibold text-base text-dark mb-2">
            {{ $t('frontend_groovemail_forms_step3_sender') }}
          </label>
          <div class="w-full">
            <div class="relative">
              <DownIcon class="h-5 w-5 absolute right-2 text-grey-600 top-2.5"/>
              <select
                class="w-full h-10 rounded-lg text-sm border border-grey-200 text-dark bg-white pl-3 pr-7 appearance-none"
                v-model="localModel.sender_id"
                value="localModel.sender_id"
                @change="setSmsSender(localModel.sender_id)"
              >
                <option :value="-1">
                  {{ $t('frontend_groovemail_sequences_email_select_sender') }}
                </option>
                <option
                  v-for="sender in this.smsSenders"
                  :value="sender.id"
                  :key="sender.id"
                  :data-name="sender.gateway_name"
                >
                  {{ sender.gateway_name }}
                </option>
              </select>
            </div>

            <div
              class="text-primary text-sm flex items-center font-semibold cursor-pointer mt-2"
              @click="createNewSmsSender"
            >
              <PlusIcon class="h-5 w-5"/>
              <p>
                {{ $t('frontend_create') }}
                {{ $t('frontend_groovemail_campaigns_sms_sender_label') }}
              </p>
            </div>
          </div>
          <!-- 
          <div class="w-full" v-if="currentSmsSender">
            <p
              class="flex items-center font-semibold text-sm text-grey-700 mt-2"
            >
              <span
                class="fa fa-info-circle"
                aria-hidden="true"
                style="font-size: 14px"
              ></span>
              <span class="ml-2"
                >{{ $t('frontend_groovemail_campaigns_sms_will_be_send') }}
                {{ currentSmsSender.country_code }}
                {{ currentSmsSender.from_number }}
                {{
                  $t('frontend_groovemail_campaigns_sms_will_be_send_via')
                }}
                {{ currentSmsSender.gateway_name }}</span
              >
            </p>
          </div> -->
        </div>
      </div>
      <!-- end step 4 -->

      <!-- start step 7 -->
      <div class="step7" v-if="currentSmsTab === 'message'">
        <div class="activeicon mb-6">
          <div class="w-full relative">
            <div class="flex justify-end mb-4">
              <div class="text-sm text-grey-700 mr-2">
                {{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_insert_varaibles') }}
              </div>
              <div
                v-click-outside="closeSmsVariables"
                class="plus-round-icon bg-primary"
                @click="openSmsVariables"
              >
                <div
                  class="bg-white btn-radius py-6 pl-6 absolute z-10 overflow-auto"
                  style="
                    width: 200px;
                    right: 0;
                    top: 35px;
                    box-shadow: 20px 20px 40px 0 rgba(22, 29, 37, 0.05);
                  "
                  v-if="showSmsVariableDropdown"
                >
                  <div class="pr-6">
                    <text-input
                      variant="base"
                      v-model="smsVariableSearch"
                      @input="changedSmsSearchVariable"
                      :placeholder="$t('frontend_groovemail_tables_search_query')"
                    >
                      <SearchIcon slot="prependIcon"/>
                    </text-input>
                  </div>
                  <VuePerfectScrollbar>
                    <div
                      class="mt-6 text-sm font-semibold"
                      style="max-height: 180px"
                    >
                      <div
                        class="mb-6"
                        v-for="(
                          option, index
                        ) in dynamic_variables_sms_content_subject"
                        :key="index"
                      >
                        <div
                          class="cursor-pointer text-grey-700 text-left"
                          @click="copySmsVariable(option)"
                        >
                          {{ option.label }}
                        </div>
                      </div>
                    </div>
                  </VuePerfectScrollbar>
                </div>
              </div>
            </div>
            <!-- <div class="header-div text-center">
              <p class="header p-2">
                {{ $t('frontend_groovemail_sequences_sendsms_content_goes') }}
              </p>
            </div> -->
            <text-area
              class="h-56"
              variant="base"
              id="sms-text-area"
              v-model="localModel.smsContent"
              :validator="$v.localModel.smsContent"
              :placeholder="$t('frontend_groovemail_campaigns_create_broadcast_enter_sms_content')"
            />
          </div>
          <div
            class="text-left pt-4"
            v-if="this.isSmsContentSubmitted && !this.localModel.smsContent"
          >
            <p class="text-sm text-danger">
              {{ $t('frontend_groovemail_campaigns_wizard_broadcasts_campaign_sms_content_empty') }}
            </p>
          </div>
        </div>
      </div>
      <!-- end step 7 -->
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { required } from 'vuelidate/lib/validators';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ClickOutside from 'vue-click-outside';

// import icons
import PlusIcon from '@/assets/images/icons/new/plus-small_new.svg';
import DownIcon from '@/assets/images/icons/new/down_new.svg';
import SearchIcon from '@/assets/images/icons/new/search_new.svg';

export default {
  name: 'SMSNode',
  props: {
    model: {
      required: true,
    },
  },

  directives: {
    ClickOutside,
  },

  data() {
    return {
      isSmsContentSubmitted: false,
      currentSmsTab: 'settings',
      currentSmsSender: '',
      localModel: this.model,
      mainselect: '',
      mainselectname: '',
      assignrecipient: '',
      assignrecipientname: '',
      smsSenders: [],
      smsVariableSearch: '',
      showSmsVariableDropdown: false,
      dynamic_variables_sms_content_subject: [],
      dynamic_variables_sms_subject: [
        {
          label: this.$t('frontend_groovemail_contacts_step2_first_name'),
          value: '{first_name}',
        },
        {
          label: this.$t('frontend_groovemail_contacts_step2_last_name'),
          value: '{last_name}',
        },
        {
          label: this.$t('frontend_groovemail_email_show_email'),
          value: '{email}',
        },
        {
          label: this.$t('frontend_groovemail_email_show_phone'),
          value: '{phone_number}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_company'),
          value: '{company}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_adress1'),
          value: '{address_1}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_adress2'),
          value: '{address_2}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_city'),
          value: '{city}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_state'),
          value: '{state}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_country'),
          value: '{country}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_zipcode'),
          value: '{zip}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_url'),
          value: '{url}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_taxnumber'),
          value: '{tax_number}',
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_billing'),
          value: '{billing_address}',
        },
        {
          label: this.$t('frontend_groovemail_contacts_step2_ip_address'),
          value: '{ip_address}',
        },
      ],
    };
  },

  validations: {
    localModel: {
      broadcast: {
        required,
      },
      smsContent: {
        required,
      },
    },
  },

  methods: {
    createNewSmsSender() {
      this.$emit('createNewSmsSender', 3);
    },

    async updateSmsSenderData(senderData) {
      const fetchedSenders = await axios.get('/sms-sender');
      this.smsSenders = fetchedSenders.data;
      if (senderData && senderData.id) {
        this.localModel.sender_id = senderData.id;
      }
    },

    handleSmsTabChange(newTab) {
      this.currentSmsTab = newTab;
    },

    closeSmsVariables() {
      this.showSmsVariableDropdown = false;
    },

    openSmsVariables() {
      this.showSmsVariableDropdown = true;
    },

    changedSmsSearchVariable(searchQuery) {
      if (searchQuery) {
        this.dynamic_variables_sms_content_subject = this.dynamic_variables_sms_subject.filter(
          (ele) => ele.label.toLowerCase().includes(searchQuery.toLowerCase())
        );
      } else {
        this.dynamic_variables_sms_content_subject = this.dynamic_variables_sms_subject;
      }
    },

    // Set the variable in the content for the SMS
    copySmsVariable(option) {
      // target element to insert variable
      const content = document.getElementById('sms-text-area');

      let position;

      if (content && content.selectionStart != null && content.selectionStart !== undefined) {
        position = content.selectionStart;
      } else {
        this.localModel.smsContent += option;
      }

      this.localModel.smsContent = [
        this.localModel.smsContent.slice(0, position),
        option.value,
        this.localModel.smsContent.slice(position),
      ].join('');

      content.focus();

      content.setSelectionRange(
        position + option.value.length,
        position + option.value.length
      );

      this.showSmsVariableDropdown = false;
      this.smsVariableSearch = '';
      this.dynamic_variables_sms_content_subject = this.dynamic_variables_sms_subject;
    },

    validate() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid;
      this.$emit('on-validate', isValid);
      if (
        !this.localModel.sender_id ||
        this.localModel.sender_id === '-1' ||
        this.$v.localModel.broadcast.$invalid
      ) {
        this.currentSmsTab = 'settings';
      } else if (this.$v.localModel.smsContent.$invalid) {
        this.currentSmsTab = 'message';
      }
      return isValid;
    },

    setSmsSender(senderId) {
      const sender = this.smsSenders.find((ele) => {
        return ele.id === senderId;
      });
      this.currentSmsSender = sender;
    },

    async fetchSmsSenders() {
      const integerationData = await axios.get('/sms-sender');
      if (
        integerationData &&
        integerationData.data &&
        integerationData.data.length
      ) {
        this.smsSenders = integerationData.data;
      }
      for (let i = 0; i < this.smsSenders.length; i += 1 ) {
        if (this.smsSenders[i].is_default === 1) {
          this.localModel.sender_id = this.smsSenders[i].id;
        }
        this.currentSmsSender = this.smsSenders[i];
      }
    },

    async fetchCustomFieldVariable() {
      try {
        const customFieldsData = await axios.post('/customfield-variables');
        customFieldsData.data.forEach( fieldData => {
          this.dynamic_variables_sms_subject.push(fieldData);
        });
      } catch (e) {
        console.log(e);
      }
    },
  },

  async created() {
    await this.fetchSmsSenders();
    await this.fetchCustomFieldVariable();
    this.dynamic_variables_sms_content_subject = this.dynamic_variables_sms_subject;
  },

  components: {
    VuePerfectScrollbar,
    PlusIcon,
    DownIcon,
    SearchIcon,
  },

  computed: {
    smsTabs() {
      return [
        {
          title: `<span class="text-sm font-semibold px-4">${this.$t(
            'frontend_groovemail_user_index_settings'
          )}</span>`,
          value: 'settings',
        },
        {
          title: `<span class="text-sm font-semibold px-4">${this.$t(
            'frontend_groovemail_sequences_edit_message'
          )}</span>`,
          value: 'message',
        },
      ];
    },

    mainTabClass() {
      return 'pb-4 gs-default-tabs-item';
    },
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },
  },
};
</script>